<template>
    <div>
        <v-container></v-container>
        <v-card>
            <v-toolbar dark color="secondary">
                <v-spacer></v-spacer>                
                <v-toolbar-title>Market Territory List</v-toolbar-title>
                <v-spacer></v-spacer>                
                <!-- 20190318, hide this feature for now -->
                <v-btn small @click.prevent="onCreateNewTerritory()" class="primary" v-if="userData.userName == 'jshi'">Add Territory</v-btn>
            </v-toolbar>
            <!-- <v-card-text>
                <v-layout>
                    <v-flex xs12 class="text-xs-center">
                    </v-flex>

                </v-layout>
            </v-card-text> -->
            <v-card-text>
                <ctlTerritories :territories="territories"
                    @onShowTerritoryCard="onShowTerritoryCard"
                    @onEditTerritory="onEditTerritory"
                    @onTerritorySaved="loadTerritories"></ctlTerritories>
            </v-card-text>

        </v-card>
        <!-- <v-dialog v-model="showTerritoryPopup" width="400" height="500">
            <ctlTerritoryCard 
                :territory="territoryToShow"
                @onCloseTerritoryCard="onCloseTerritoryCard"
                @onEditTerritory="onEditTerritory"
                ></ctlTerritoryCard>
        </v-dialog> -->
        <v-dialog v-model="showTerritoryEditPopup" persistent width="400" height="500">
            <ctlTerritoryEdit 
                :id="regionIdToEdit"
                @onCloseTerritoryEdit="onCloseTerritoryEdit"
                ></ctlTerritoryEdit>
        </v-dialog>

    </div>

</template>
<script>
import ctlTerritories from '@/components/admin/ctlTerritories'
import ctlTerritoryCard from '@/components/admin/ctlTerritoryCard'
import ctlTerritoryEdit from '@/components/admin/ctlTerritoryEdit'
import { mapActions, mapGetters } from 'vuex'

export default {
    components: {
        'ctlTerritories': ctlTerritories,
        'ctlTerritoryCard': ctlTerritoryCard,
        'ctlTerritoryEdit': ctlTerritoryEdit,
    },
    data () {
        return {
            territories: [],
            territoryToShow: null,
            territoryIdToEdit: null,
            showTerritoryEditPopup: false,
            regionIdToEdit: null,
        }
    },
    computed: {
        ...mapGetters('auth', [
            'userData'
        ]),
        // showTerritoryPopup () {
        //     return !!this.territoryToShow
        // },
    },
    methods: {
        ...mapActions('adminMarket', [
            'getAllTerritories'
        ]),
        onCreateNewTerritory () {
            this.showTerritoryEditPopup = true
            // this.$router.push({name: 'admin-region-new'})
        },
        async loadTerritories () {
            this.territories = await this.getAllTerritories()
        },
        onEditTerritory(id) {
            this.showTerritoryEditPopup = true
            this.regionIdToEdit = id
        },

        onCloseTerritoryEdit() {
            this.showTerritoryEditPopup = false
            this.regionIdToEdit = null
            this.loadTerritories()
        },
        onShowTerritoryCard(territory) {
            this.territoryToShow = territory
        },
        onCloseTerritoryCard() {
            this.territoryToShow = null
        },

    },
    async created () {
        this.loadTerritories()
    }
}
</script>
